import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { TravelEstimateReport } from '../modules/ComponentsLibrary/TravelEstimateReport';

export const Route = createFileRoute('/travel-estimate/$jobNumber')({
  component: TravelEstimatePage,
  params: z.object({
    jobNumber: z.coerce.number().positive(),
  }),
  loader(ctx) {
    const hasCostReportAccess = ctx.context.authContext.user.permissionGroups.some(
      (group) => group.name === 'CostReportAccess',
    );
    if (!hasCostReportAccess) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to view travel estimate reports. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head(ctx) {
    return {
      meta: [{ title: `Travel Estimate | Job #${ctx.params.jobNumber}` }],
    };
  },
});

function TravelEstimatePage() {
  const { jobNumber } = Route.useParams();
  return (
    <div className="theme-light min-h-screen">
      <TravelEstimateReport serviceCallId={jobNumber} />
    </div>
  );
}
